import api from './api';

/**
 * Admin API Service
 * Provides methods for system admin to edit any table
 */

// List all editable tables
export const listTables = () => api.get('/admin/tables');

// Get table schema
export const getTableSchema = (tableName) => api.get(`/admin/tables/${tableName}/schema`);

// List records in a table
export const listRecords = (tableName, params = {}) =>
  api.get(`/admin/tables/${tableName}/records`, { params });

// Get a single record
export const getRecord = (tableName, id) =>
  api.get(`/admin/tables/${tableName}/records/${id}`);

// Create a record
export const createRecord = (tableName, data, reason = null) =>
  api.post(`/admin/tables/${tableName}/records`, { data, reason });

// Update a record
export const updateRecord = (tableName, id, updates, reason = null) =>
  api.put(`/admin/tables/${tableName}/records/${id}`, { updates, reason });

// Delete a record
export const deleteRecord = (tableName, id, reason = null) =>
  api.delete(`/admin/tables/${tableName}/records/${id}`, { data: { reason } });

// Bulk update records
export const bulkUpdateRecords = (tableName, ids, updates, reason = null) =>
  api.put(`/admin/tables/${tableName}/records/bulk`, { ids, updates, reason });

// Get record history
export const getRecordHistory = (tableName, id) =>
  api.get(`/admin/tables/${tableName}/records/${id}/history`);

// Get all admin edit logs
export const getAdminEditLogs = (params = {}) =>
  api.get('/admin/edit-logs', { params });

export default {
  listTables,
  getTableSchema,
  listRecords,
  getRecord,
  createRecord,
  updateRecord,
  deleteRecord,
  bulkUpdateRecords,
  getRecordHistory,
  getAdminEditLogs
};
